export enum ApprovalStatus {
  PENDING = "pending",
  APPROVED = "approved",
  DENIED = "denied",
}

export enum AllowListType {
  USER = "user",
  DOMAIN = "domain",
  FILE = "file",
}

export interface AllowListUser {
  email: string;
  createdAt?: Date;
}

export interface AllowListDomain {
  domain: string;
  createdAt?: Date;
}

export interface AllowListFile {
  id: string;
  name: string;
  type: string;
  createdAt?: Date;
}

export interface AllowListResponse {
  approved: {
    users: AllowListUser[];
    domains: AllowListDomain[];
    files: AllowListFile[];
  };
  pending: {
    users: AllowListUser[];
    domains: AllowListDomain[];
    files: AllowListFile[];
  };
}
